import { Dialog, DialogActions, DialogContent } from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import Icon from '@mui/material/Icon';
import { StructuredOutputBuilder } from './structuredOutputBuilder';
import MDButton from 'components/MDButton';

function StructuredOutputBuilderDialog({
  dialogOpen,
  setDialogOpen,
  initialSchema = null,
  onSave
}) {
  const { formatMessage: msg } = useIntl();
  const [currentSchema, setCurrentSchema] = useState(initialSchema || {});

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const handleSchemaChange = (schema) => {
    setCurrentSchema(schema);
  };

  const handleSave = () => {
    if (onSave) {
      onSave(currentSchema);
    }
    setDialogOpen(false);
  };

  return (
    <Dialog
      open={dialogOpen}
      onClose={handleCloseDialog}
      fullWidth
      PaperProps={{
        sx: {
          height: '90vh',
          maxHeight: '90vh',
          width: '80vw',
          maxWidth: '80vw'
        }
      }}
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center' }}>
        <Icon
          fontSize="large"
          sx={{
            color: (theme) => theme.palette.primary.main,
            mr: 1
          }}
        >
          settings_icon
        </Icon>
        {msg({ id: 'field.structuredOutput.dialog.title' })}
      </DialogTitle>
      <DialogContent sx={{ padding: 0, margin: 0, height: '100%', display: 'flex' }} dividers>
        <StructuredOutputBuilder initialSchema={initialSchema} onChange={handleSchemaChange} />
      </DialogContent>
      <DialogActions>
        <MDButton onClick={handleCloseDialog} color="secondary">
          {msg({ id: 'button.close' })}
        </MDButton>
        <MDButton onClick={handleSave} color="primary">
          {msg({ id: 'action.save' })}
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}

StructuredOutputBuilderDialog.propTypes = {
  dialogOpen: PropTypes.bool.isRequired,
  setDialogOpen: PropTypes.func.isRequired,
  initialSchema: PropTypes.object,
  onSave: PropTypes.func
};

export default StructuredOutputBuilderDialog;
